export const Portfolio = {
    "data" : [
        {
            "thumb": "assets/portfolio/debora/capa.jpg",
            "title": "Débora Molina",
            "description": "Psicopedagoga",
            "images": [
                "assets/portfolio/debora/10.jpg",
                "assets/portfolio/debora/20.jpg",
                "assets/portfolio/debora/30.jpg",
                "assets/portfolio/debora/40.jpg",
                "assets/portfolio/debora/50.jpg",
                "assets/portfolio/debora/60.jpg",
            ]
        },        
        {
            "thumb": "assets/portfolio/clayton/capa.jpg",
            "title": "Clayton Carbo",
            "description": "Fisioterapeuta",            
            "images": [
                "assets/portfolio/clayton/10.jpg",
                "assets/portfolio/clayton/20.jpg",
                "assets/portfolio/clayton/30.jpg",
                "assets/portfolio/clayton/40.jpg",
                "assets/portfolio/clayton/50.jpg",
            ]                       
        },
        {
            "thumb": "assets/portfolio/cristiana/capa.jpg",
            "title": "Cristiana Alves",
            "description": "Podóloga",            
            "images": [
                "assets/portfolio/cristiana/10.jpg",
                "assets/portfolio/cristiana/20.jpg",
                "assets/portfolio/cristiana/30.jpg",
                "assets/portfolio/cristiana/40.jpg",
            ]                       
        },
        {

            "thumb": "assets/portfolio/renata/capa.jpg",
            "title": "Renata Jonas",
            "description": "Terapeuta holística",            
            "images": [
                "assets/portfolio/renata/10.jpg",
                "assets/portfolio/renata/20.jpg",
                "assets/portfolio/renata/30.jpg",
                "assets/portfolio/renata/40.jpg",
            ]                       
        },    
        {
            "thumb": "assets/portfolio/guilherme/capa.jpg",
            "title": "Guilherme Segura",
            "description": "Fisioterapeuta Quiropraxista",            
            "images": [
                "assets/portfolio/guilherme/10.jpg",
                "assets/portfolio/guilherme/20.jpg",
                "assets/portfolio/guilherme/30.jpg",
                "assets/portfolio/guilherme/40.jpg",
            ]                       
        },              
        {
            "thumb": "assets/portfolio/fran/capa.jpg",
            "title": "Fran Saraiva",
            "description": "Designer de Sombrancelha",            
            "images": [
                "assets/portfolio/fran/10.jpg",
                "assets/portfolio/fran/20.jpg",
                "assets/portfolio/fran/30.jpg",
                "assets/portfolio/fran/40.jpg",
            ]                       
        },                      
        {
            "thumb": "assets/portfolio/fernanda/capa.jpg",
            "title": "Fernanda Santos",
            "description": "Figura pública",            
            "images": [
                "assets/portfolio/fernanda/10.jpg",
                "assets/portfolio/fernanda/20.jpg",
                "assets/portfolio/fernanda/30.jpg",
                "assets/portfolio/fernanda/40.jpg",
            ]                       
        },
        {
            "thumb": "assets/portfolio/andre/capa.jpg",
            "title": "André Silva",
            "description": "Fisioterapeuta",            
            "images": [
                "assets/portfolio/andre/10.jpg",
                "assets/portfolio/andre/20.jpg",
                "assets/portfolio/andre/30.jpg",
                "assets/portfolio/andre/40.jpg",
            ]                       
        }      
    ]
};


